import { createFileRoute, Link, notFound } from "@tanstack/react-router";

import { HubPlacePage, hubPlaceQuery } from "@/components/hubs/HubPlacePage";
import { hubPlaceHead } from "@/lib/hub-seo";

export const Route = createFileRoute("/fi/bars/$slug")({
  loader: async ({ params, context }) => {
    const data = await context.queryClient.ensureQueryData(hubPlaceQuery("bars", params.slug));
    if (!data) throw notFound();
    return data;
  },
  head: ({ params, loaderData }) =>
    hubPlaceHead({ path: `/fi/bars/${params.slug}`, locale: "fi", loaderData }),
  component: BarsFiPlaceRoute,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div>
        <h1 className="font-heading text-2xl">Baaria ei löytynyt</h1>
        <Link to="/fi/bars" className="mt-6 inline-block text-royal underline">
          Selaa kaikkia
        </Link>
      </div>
    </div>
  ),
});

function BarsFiPlaceRoute() {
  const { slug } = Route.useParams();
  return <HubPlacePage hubSlug="bars" placeSlug={slug} locale="fi" />;
}
